import {AnyFactoryGame, FactoryGameType, Item, Recipe} from "../types";
import {
    getAllRecipes as getAllRecipesSatisfactory,
    getRecipe as getRecipeSatisfactory
} from "../Satisfactory/Data/Recipes";
import {getAllRecipes as getAllRecipesDysonSphere, getRecipe as getRecipeDysonSphere} from "../DSP/Data/Recipes";
import { Item as ItemSatisfactory } from '../Satisfactory/types';
import { Item as ItemDysonSphere } from '../DSP/types';

export function getAllRecipes<T extends AnyFactoryGame>(gameType: FactoryGameType): Recipe<T>[] {
    switch (gameType) {
        case FactoryGameType.Satisfactory: return getAllRecipesSatisfactory() as Recipe<T>[];
        case FactoryGameType.DysonSphere: return getAllRecipesDysonSphere() as Recipe<T>[];
    }
}

export function getRecipe<T extends AnyFactoryGame>(gameType: FactoryGameType, recipeName: string): Recipe<T> | null {
    switch (gameType) {
        case FactoryGameType.Satisfactory: return getRecipeSatisfactory(recipeName) as Recipe<T>;
        case FactoryGameType.DysonSphere: return getRecipeDysonSphere(recipeName) as Recipe<T>;
    }
}

export function getRecipesForProduct<T extends AnyFactoryGame>(gameType: FactoryGameType, product: Item<T>): Recipe<T>[] {
    const recipes = getAllRecipes<T>(gameType);
    return recipes.filter(recipe => recipe.products.some(_product => _product.item === product));
}

export function getAllItems<T extends AnyFactoryGame>(gameType: FactoryGameType): Item<T>[] {
    switch (gameType) {
        case FactoryGameType.Satisfactory: return Object.values(ItemSatisfactory) as Item<T>[];
        case FactoryGameType.DysonSphere: return Object.values(ItemDysonSphere) as Item<T>[];
    }
}
